export const FONT_FAMILY_MAIN= "IBM Plex Sans";
export const FONT_FAMILY_CONDENSED= "IBM Plex Sans Condensed";


// WEBPACK FOOTER //
// ./src/opencell/constants/fonts.js